import React, { useEffect } from "react";
import {
  MetricsState,
  Api,
} from "@amzn/squad-front-end-shared-react-components";
import { JobObject } from "./components";
import { JobTypeProps } from "./components/MyJobs";
import { MyJobs } from "./components";
import { connect } from "react-redux";
import { RootState } from "../redux/rootReducer";
import JobDescription from "./JobDescription";
import JobMapping from "./job-mappings";
import helpPanelSlice, { DisplayHelpPanel } from "../help_panel/helpPanelSlice";

export interface JobsPageWrapperProps {
  metrics: MetricsState;
}

export interface JobsPageWrapperDispatchProps {
  setHelpPanelContent: (payload: DisplayHelpPanel | undefined) => void;
  setHelpPanelOpenState: (payload: boolean | true) => void;
}

const api = new Api(process.env.API_BASE_URL);
const getWorkflowsUrl = api.getEndpointUri("/api/v1/workflows");

const getFormattedJobType = (props: JobTypeProps): string => {
  const job = props.job;
  const jobName = JobMapping.get(job.name);
  if (!jobName) {
    return job.name;
  }
  return jobName.formattedJobType;
};

const getRetryWorkflowUrl = (job: JobObject): string => {
  let retryPath = job.name;
  const jobInfo = JobMapping.get(job.name);
  if (!!jobInfo) {
    retryPath = jobInfo.retryEndpoint;
  }

  return `${getRetryWorkflowUrl}/${retryPath}/${job.instanceId}/start`;
};

const helpPanelContent = {
  header: "System tasks",
  contentType: "test",
  widenContent: false,
  customContent: "View and manage your pending and completed system tasks.",
} as const;

const JobsPageWrapper: React.FC<JobsPageWrapperProps &
  JobsPageWrapperDispatchProps> = ({
  metrics,
  setHelpPanelContent,
  setHelpPanelOpenState,
}): JSX.Element => {
  useEffect(() => {
    setHelpPanelContent(helpPanelContent);
  }, [setHelpPanelContent]);

  const handleInfoLinkClick = () => {
    setHelpPanelContent(helpPanelContent);
    setHelpPanelOpenState(true);
  };

  return (
    <MyJobs
      metrics={metrics}
      getWorkflowsUrl={getWorkflowsUrl}
      getFormattedJobType={getFormattedJobType}
      getJobDescription={JobDescription}
      getRetryWorkflowUrl={getRetryWorkflowUrl}
      workflowFilter={() => true}
      onInfoLinkClick={handleInfoLinkClick}
    />
  );
};

const mapStateToProps = ({ metrics }: RootState): JobsPageWrapperProps => {
  return {
    metrics,
  };
};

const mapDispatchToProps = {
  setHelpPanelContent: helpPanelSlice.actions.setHelpPanelContent,
  setHelpPanelOpenState: helpPanelSlice.actions.setHelpPanelOpenState,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobsPageWrapper);
